// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#wpcontent {
    padding-left: 0px;
}
.wrap {
    margin: unset;
}
.easycommerce-custom-date-field .react-datepicker-wrapper input {
    width: 100%;
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
    margin-bottom: 10px;
}
.easycommerce-custom-date-field .react-datepicker-wrapper input:focus {
    box-shadow: none;
    border: 1px solid var(--color-ec-primary);
}
.easycommerce .easycommerce-report-product-search-input {
    padding: 8px 15px;
    color: var(--color-ec-body);
    border: 1px solid #dbdbdb;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 26px;
    border-radius: 8px;
}
.easycommerce .easycommerce-report-product-search-input::-moz-placeholder {
    font-size: 16px;
    color: var(--color-ec-placeholder);
    font-family: "Inter", sans-serif;
}
.easycommerce .easycommerce-report-product-search-input::placeholder {
    font-size: 16px;
    color: var(--color-ec-placeholder);
    font-family: "Inter", sans-serif;
}
.easycommerce .easycommerce-report-product-search-input:focus {
    border: 1px solid #dbdbdb;
    box-shadow: none;
}

.toplevel_page_easycommerce-store ul.wp-submenu li.current {
    box-shadow: inset 4px 0 0 0 #ffffff !important;
    transition: box-shadow .1s linear;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/css/store-menu.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,yCAAyC;AAC7C;AACA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,gCAAgC;AACpC;AAJA;IACI,eAAe;IACf,kCAAkC;IAClC,gCAAgC;AACpC;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,iCAAiC;AACrC","sourcesContent":["#wpcontent {\n    padding-left: 0px;\n}\n.wrap {\n    margin: unset;\n}\n.easycommerce-custom-date-field .react-datepicker-wrapper input {\n    width: 100%;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n    margin-bottom: 10px;\n}\n.easycommerce-custom-date-field .react-datepicker-wrapper input:focus {\n    box-shadow: none;\n    border: 1px solid var(--color-ec-primary);\n}\n.easycommerce .easycommerce-report-product-search-input {\n    padding: 8px 15px;\n    color: var(--color-ec-body);\n    border: 1px solid #dbdbdb;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    line-height: 26px;\n    border-radius: 8px;\n}\n.easycommerce .easycommerce-report-product-search-input::placeholder {\n    font-size: 16px;\n    color: var(--color-ec-placeholder);\n    font-family: \"Inter\", sans-serif;\n}\n.easycommerce .easycommerce-report-product-search-input:focus {\n    border: 1px solid #dbdbdb;\n    box-shadow: none;\n}\n\n.toplevel_page_easycommerce-store ul.wp-submenu li.current {\n    box-shadow: inset 4px 0 0 0 #ffffff !important;\n    transition: box-shadow .1s linear;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
